/**
 * PROVISIONING-PHYSICAL-QR-CAMERA-1 — tratamento unificado do QR FÍSICO numérico
 * impresso na lateral do Sonoff (ex.: "25082200178100").
 *
 * Decisão de produto: o qr_serial oficial é o número decimal do QR físico —
 * identificador (NÃO segredo), único por equipamento. Nesta fase aceitamos
 * APENAS dígitos.
 *
 *   " 25082200178100 " → "25082200178100"  (válido)
 *   "2508 2200 178100" → "25082200178100"  (válido — espaços removidos)
 *   "2508-2200"        → inválido (hífen)
 *   "https://..."      → inválido (URL/símbolos)
 *   "abc2508"          → inválido (letras)
 */

export const PHYSICAL_QR_ERROR =
  "Informe apenas o número do QR físico impresso no Sonoff.";

/** Normaliza: remove TODOS os espaços/whitespace (e faz trim implícito). NÃO
 *  remove outros caracteres — assim hífen/letras continuam reprovando na
 *  validação. */
export function normalizePhysicalQr(input) {
  if (input == null) return "";
  return String(input).replace(/\s+/g, "");
}

/** True se, após normalizar, sobra só dígitos (8–40). */
export function isValidPhysicalQr(input) {
  return /^[0-9]{8,40}$/.test(normalizePhysicalQr(input));
}
